// src/components/RequireAdmin.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const RequireAdmin = ({ children }) => {
  const location = useLocation();
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    user = null;
  }

  // Not authenticated → go to login
  if (!user || !user.userid) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Authenticated but not admin → bounce to dashboard
  const isAdmin =
    user.isadmin === 1 ||
    user.isadmin === true ||
    String(user.isadmin) === '1';

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RequireAdmin;
